import { local } from "@/lib/storage";

const KEY = "esi.lastProject";

/** The last project the user opened, to preselect on home. An ID only; nothing else is kept. */
export const lastProject = {
  read: (): string | null => local.get(KEY),
  write: (projectId: string): void => local.set(KEY, projectId),
  /** Forgets `projectId` if it is the one remembered (a deleted project). */
  forget: (projectId: string): void => {
    if (local.get(KEY) === projectId) {
      local.set(KEY, null);
    }
  },
};
